<template>
  <section>
    <br>
    <div class="al-tabs-container">
      <!-- <div class="al-tabs-title" v-if="tabs.length > 1">
        <template v-for="tab in tabs">
          <button
            v-bind:key="tab.id"
            @click="handleSelectTab(tab.id)"
            class="button"
            :class="selectedTab === tab.id ? 'selected' : ''"
          >
            {{ tab.title }}
          </button>
        </template>
      </div> -->
      <!-- <h1 class="title">
        {{ pageTitle }}
      </h1> -->
      <liens />
      <!-- <div class="al-tabs">
        <div v-if="selectedTab === allTabs.USPS" class="al-tab">
          <usps-emails></usps-emails>
        </div>
        <div v-if="selectedTab === allTabs.NEWSPAPER_ADS" class="al-tab">
          <newspaper-ads></newspaper-ads>
        </div>
        <div v-if="selectedTab === allTabs.LIEN" class="al-tab">
          <liens></liens>
        </div>
        <div v-if="selectedTab === allTabs.APPROVAL" class="al-tab">
          <final-approval></final-approval>
        </div>
        <div v-if="selectedTab === allTabs.LIENS_OVERDUE" class="al-tab">
          <liens-overdue></liens-overdue>
        </div>
        <div v-if="selectedTab === allTabs.AUCTION" class="al-tab">
          <liens-auction></liens-auction>
        </div>
        <div v-if="selectedTab === allTabs.LIBRARY" class="al-tab">
          <library />
        </div>
        <div v-if="selectedTab === allTabs.TENANTS_EMAIL" class="al-tab">
          <tenants-email />
        </div>
        <div v-if="selectedTab === allTabs.NEWSPAPER_STEP" class="al-tab">
          <newspaper-step></newspaper-step>
        </div>
      </div> -->
    </div>
    <br>
  </section>
</template>
<script>
// import UspsEmails from "./UspsEmails";
// import NewspaperAds from "./NewspaperAds";
// import FinalApproval from "./FinalApproval";
// import LiensOverdue from "@/components/dashboard/LiensOverdue";
// import LiensAuction from "@/components/dashboard/Auction";
// import Library from "@/components/dashboard/Library";
// import TenantsEmail from "@/components/dashboard/TenantsEmail";
// import NewspaperStep from "@/components/dashboard/NewspaperStep.vue";
import Liens from './Liens';
import { Roles } from '@/constants';
import { TABS } from '@/constants/dashboard';

export default {
  name: 'DashboardComponent',
  components: {
    Liens
    // LiensOverdue,
    // UspsEmails,
    // NewspaperAds,
    // FinalApproval,
    // LiensAuction,
    // Library,
    // TenantsEmail,
    // NewspaperStep,
  },
  data() {
    return {
      role: this.$store.state.user.role,
      tabs: [],
      selectedTab: null,
      allTabs: TABS
    };
  },
  computed: {
    pageTitle() {
      return this.selectedTab === TABS.USPS
        ? 'Letters Pending'
        : 'Follow on going procedures';
    }
  },
  mounted() {
    this.generateTabs();
  },
  methods: {
    handleSelectTab(key) {
      this.selectedTab = key;
      this.$store.commit('setSelectedTab', { dashboard: key });
    },
    generateTabs() {
      const { role } = this;
      const showUSPS = role === Roles.SUPER_ADMIN;
      const showNewspaperAds = role === Roles.SUPER_ADMIN;
      const showTenantsEmail = role === Roles.SUPER_ADMIN;
      const showApproval = [
        Roles.ADMIN,
        Roles.CS_ADMIN,
        Roles.SUPER_ADMIN
      ].includes(role);
      const showLiensOverdue = [
        Roles.ADMIN,
        Roles.CS_ADMIN,
        Roles.SUPER_ADMIN
      ].includes(role);
      const showNewspaperStep = role === Roles.SUPER_ADMIN;
      const tabs = [
        {
          id: TABS.LIEN,
          title: 'Liens',
          visible: true
        }
      ];

      if (showUSPS) {
        tabs.push({
          id: TABS.USPS,
          title: 'Letters',
          visible: true
        });
      }

      if (showNewspaperAds) {
        tabs.push({
          id: TABS.NEWSPAPER_ADS,
          title: 'Ads',
          visible: true
        });
      }

      if (showApproval) {
        tabs.push({
          id: TABS.APPROVAL,
          title: 'Approvals',
          visible: true
        });
      }

      if (showLiensOverdue) {
        tabs.push({
          id: TABS.AUCTION,
          title: 'Auctions',
          visible: true
        });
      }

      if (showLiensOverdue) {
        tabs.push({
          id: TABS.LIENS_OVERDUE,
          title: 'Liens Overdue',
          visible: true
        });
      }

      if (showTenantsEmail) {
        tabs.push({
          id: TABS.TENANTS_EMAIL,
          title: 'Tenants Email',
          visible: true
        });
      }

      if (showNewspaperStep) {
        tabs.push({
          id: TABS.NEWSPAPER_STEP,
          title: 'Newspaper Step',
          visible: true
        });
      }

      this.tabs = [
        ...tabs,
        {
          id: TABS.LIBRARY,
          title: 'Library',
          visible: true
        }
      ];
      this.selectedTab = this.$store.state.tabs.dashboard || this.tabs[0].id;
    }
  },
  events: {
    'tab-selected': function (tab) {
      this.selectedTab = tab;
    }
  }
};
</script>
<style scoped lang="scss">
.global-info p {
  border-left-width: 4px;
  border-left-style: solid;
  padding-left: 1rem;
}
</style>
